import { useClock, formatCityTime } from '../lib/useClock';
import { profile } from '../lib/static-data';

export function CityClocks() {
  const time = useClock();

  return (
    <div
      className="city-clocks"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        borderTop: '1px solid var(--ink)',
        borderBottom: '1px solid var(--ink)',
        marginTop: 36,
      }}
    >
      {profile.cities.map((c, i, a) => (
        <div
          key={c.code}
          style={{
            padding: '14px 20px',
            borderRight: i < a.length - 1 ? '1px solid var(--ink)' : 'none',
            display: 'flex',
            alignItems: 'baseline',
            gap: 12,
          }}
        >
          <div
            style={{
              fontSize: 10,
              textTransform: 'uppercase',
              letterSpacing: 1.5,
              opacity: 0.6,
            }}
          >
            {c.code}
          </div>
          <div
            style={{
              flex: 1,
              borderBottom: '1px dotted var(--soft)',
              transform: 'translateY(-3px)',
            }}
          />
          <div
            className="tabular"
            style={{
              fontFamily: 'var(--font-mono)',
              fontSize: 15,
              fontWeight: 500,
            }}
          >
            {formatCityTime(time, c.tz)}
          </div>
        </div>
      ))}
    </div>
  );
}
